import { BrandStatusSeverity, BrandStatusType } from '@centric-os/types';
import { storeToRefs } from 'pinia';
import { useBrandStore } from '../../use-brand-store';

const useBrandRefresh = () => {
  const refreshPublishedBrandAfterUpdates = () => {
    const brandStore = useBrandStore();
    const { brand } = storeToRefs(brandStore);

    const publishedStatus = brand.value?.statuses?.find(
      (el) => el.status === BrandStatusSeverity.OK && el.type === BrandStatusType.PUBLISH,
    );

    if (publishedStatus) {
      brandStore.getBrandForRefresh(brand.value.id);
    }
  };

  return {
    refreshPublishedBrandAfterUpdates,
  };
};

export default useBrandRefresh;
export { useBrandRefresh };
